import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const WorkspaceContext = createContext(null);

export function WorkspaceProvider({ children }) {
  const { user } = useAuth();
  const [workspaces, setWorkspaces] = useState([]);
  const [currentWorkspace, setCurrentWorkspace] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchWorkspaces = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get("/workspaces");
      setWorkspaces(data);
      // pick default
      const savedId = localStorage.getItem("bloq_workspace_id");
      const defaultId = user.default_workspace_id;
      const pick =
        data.find((w) => w.workspace_id === savedId) ||
        data.find((w) => w.workspace_id === defaultId) ||
        data[0];
      if (pick) {
        setCurrentWorkspace(pick);
        localStorage.setItem("bloq_workspace_id", pick.workspace_id);
      }
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user) fetchWorkspaces();
    else {
      setWorkspaces([]);
      setCurrentWorkspace(null);
    }
  }, [user, fetchWorkspaces]);

  const switchWorkspace = (workspace_id) => {
    const next = workspaces.find((w) => w.workspace_id === workspace_id);
    if (next) {
      setCurrentWorkspace(next);
      localStorage.setItem("bloq_workspace_id", next.workspace_id);
    }
  };

  return (
    <WorkspaceContext.Provider
      value={{ workspaces, currentWorkspace, switchWorkspace, fetchWorkspaces, loading }}
    >
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspace() {
  return useContext(WorkspaceContext);
}
